'use client'
import styles from './page.module.sass'
import Header from "@/components/Header/Header"
import EnterAnimation from "@/components/EnterAnimation/EnterAnimation"
import Hero from "@/components/Hero/Hero"
import ContactUs from "@/components/ContactUs/ContactUs"
import Footer from "@/components/Footer/Footer"
import Game from "@/components/Game/Game"
import GameProvider from "@/context/GameContext"
import ContactForm from "@/components/ContactForm/ContactForm"
import Cards from "@/components/Cards/Cards"
import useSmoothScroll from '@/hooks/useSmoothScroll'
import {useEffect} from "react"

export default function Home() {
	useSmoothScroll()

	// Listen the click event
	useEffect(() => {
		window.addEventListener('click', handleClick)
		return () => {
			window.removeEventListener('click', handleClick)
		}
	}, []);

	const handleClick = (e) => {
		// If we click on an element with the class "custom_pointer"
		if (e.target.closest('.custom_pointer')) {
			e.target.classList.add('click_cursor');

			setTimeout(() => {
				e.target.classList.remove('click_cursor');
			}, 200)

			// Remove focus on the element
			e.target.blur();
		}
	};

	return (
			<main className={styles.page}>
				<GameProvider>
					{/*Enter Animation*/}
					<EnterAnimation/>

					{/*Header*/}
					<Header/>

					{/*Hero*/}
					<Hero/>

					{/*Game*/}
					<Game/>

					{/*Cards*/}
					<Cards/>

					{/*Contact Us*/}
					<ContactUs/>

					{/*Contact Form*/}
					<ContactForm/>

	                {/*Footer*/}
					<Footer/>
				</GameProvider>
            </main>
    );
}
